import { type WorkspaceAgentMessagePill } from '~/components/v2/components/workspace/workspace-agent-panel/schemas/pillMetadata';
import { findWorkspaceAgentMessagePill } from '~/components/v2/components/workspace/workspace-agent-panel/utils/findWorkspaceAgentMessagePill';
import { splitPillMonikers } from '~/components/v2/components/workspace/workspace-agent-panel/utils/splitPillMonikers';

export type PartitionWorkspaceAgentMessagePillsParams = {
  content: string;
  pills: readonly WorkspaceAgentMessagePill[];
};

export type PartitionedWorkspaceAgentMessagePills = {
  /** Cited by a moniker in `content` — render inline. */
  citedPillIds: Set<string>;
  /** No moniker points at them (grid / scope-bar selection) — render above the bubble. */
  uncitedPills: WorkspaceAgentMessagePill[];
};

/** Inline vs scope-bar pills share one `metadata.pills` array; only the message text tells them apart. */
export const partitionWorkspaceAgentMessagePills = ({
  content,
  pills,
}: PartitionWorkspaceAgentMessagePillsParams): PartitionedWorkspaceAgentMessagePills => {
  const citedPillIds = new Set<string>();

  for (const segment of splitPillMonikers(content)) {
    if (segment.type !== 'pill') {
      continue;
    }

    const pill = findWorkspaceAgentMessagePill(pills, segment.monikerId);

    if (pill) {
      citedPillIds.add(pill.id);
    }
  }

  return { citedPillIds, uncitedPills: pills.filter((pill) => !citedPillIds.has(pill.id)) };
};
